// STRICT - @ts-expect-error - to be typed
import FESegmentUtils from '@spothero/utils/segment';
export const withLoggedInStatus = () => {
    const traits = FESegmentUtils.getUserTraits();
    return traits?.email ? { user_logged_in: true } : { user_logged_in: false };
};
